import React from "react";

import { Protocols } from "../../containers/Protocols/Protocols";

export const ProtocolsView = props => {
    const { match: { params } } = props;

    return (<Protocols protocolId={params.protocolId} />);
}